import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom'
import { fetchCustomers, syncCustomer } from '../store/actions/customers';
import CustomerList from '../components/customerList';
import { cancelTimePickerDialog, closeTimePickerDialog, openTimePickerDialog} from '../store/actions/timepick';
import { authRedirect } from '../lib/utils';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.customers,
        ...state.searchKey,
        ...state.paging,
        onCreateCustomerClick: () => {
            ownProps.history.push(`/customers/new`)
        },
        openCustomer: (index) => {
            let customer = state.customers.customers[index];
            ownProps.history.push(`/customers/${customer.id}`)
        },
        timepickDialog: {...state.timepick}
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchCustomers: (key, page) => dispatch(fetchCustomers(key, page)).catch(authRedirect(ownProps)),
        syncCustomer: (id, params) => dispatch(syncCustomer(id, params)),
        openTimePickerDialog: (id) => dispatch(openTimePickerDialog(id)),
        closeTimePickerDialog: () => dispatch(closeTimePickerDialog()),
        cancelTimePickerDialog: () => dispatch(cancelTimePickerDialog())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchCustomers( this.props.searchKey?this.props.searchKey:0, (this.props.paging && this.props.paging.number)?this.props.paging.number:"");
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(CustomerList);



// WEBPACK FOOTER //
// ./src/containers/CustomersContainer.js